import React, { useEffect } from "react";
import { useApplicationContext } from "../../components/applicationComponents/context/applicationContext";
import ApplicationCreationComponent from "../../components/applicationComponents/applicationCreation/ApplicationCreationComponent";

export default function ApplicationCreationPage() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Application Creation",
      icon: "view-app-icon icon-spec mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ApplicationCreationComponent disabled={false} />
    </>
  );
}
